
import { LazyImgComponent } from './lazy-img';
import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { PinchZoomModule } from 'ngx-pinch-zoom';
@NgModule({
    declarations: [LazyImgComponent],
    imports: [IonicModule, PinchZoomModule],
    exports: [LazyImgComponent]
})
export class LazyImgComponentModule {
}



// WEBPACK FOOTER //
// ./src/components/lazy-img/lazy-img.module.ts